export class Door {
  id: number;
  name: string;

  public constructor(init?: Partial<Door>) {
    Object.assign(this, init);
  }
}
